export default __webpack_public_path__ + "static/media/spratt9.8a44cd79.jpg";